import React, { HTMLAttributes } from 'react';
import styled from '@emotion/styled';

import Img from '@/components/atoms/Img';
import Typography from '@/components/atoms/Typography';

import ImageDataType from '@/types/data/image';
import mq from '@/styles/mq';

export interface MemberProps {
  hidden_photo?: ImageDataType | null;
  photo?: ImageDataType | null;
  name?: string | null;
  role?: string | null;
}

interface Props
  extends Omit<HTMLAttributes<HTMLDivElement>, 'role'>,
    MemberProps {}

const TeamMemberRoot = styled('div')``;

const MemberPhoto = styled(Img)`
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: block;
  border-radius: 10px;
  margin-left: auto;
  margin-right: auto;
  height: 280px;
  width: 250px;
  transition: 0.7s;
  ${mq('md')} {
    height: 360px;
    width: 320px;
  }

  ${mq('lg')} {
    height: 450px;
    width: 400px;
  }
`;
const HiddenPhoto = styled(Img)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  display: block;
  border-radius: 10px;
  margin-left: auto;
  margin-right: auto;
  height: 280px;
  width: 250px;
  transition: 0.7s;
  ${mq('md')} {
    height: 360px;
    width: 320px;
  }

  ${mq('lg')} {
    height: 450px;
    width: 400px;
  }
`;
const PhotoContainer = styled('div')`
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  transition: 0.7s;
  &:hover ${MemberPhoto} {
    opacity: 0;
  }
  &:hover ${HiddenPhoto} {
    opacity: 1;
  }
`;
const Name = styled(Typography)`
  text-align: center;
  margin-top: ${({ theme }) => theme.spacing(2)};
  font-weight: 900;
`;
const Role = styled(Typography)`
  text-align: center;
  margin-top: ${({ theme }) => theme.spacing(1)};
  font-size: 2rem;
`;

const TeamMember = ({
  hidden_photo,
  photo,
  name,
  role,
  ...rest
}: Props): JSX.Element => {
  const { url, alt } = photo || {};

  return (
    <TeamMemberRoot {...rest}>
      <PhotoContainer>
        {url && <MemberPhoto src={url} alt={alt || ''} />}
        {hidden_photo?.url && (
          <HiddenPhoto
            src={hidden_photo?.url}
            alt={hidden_photo?.alt || ''}
            width={400}
            height={450}
          />
        )}
      </PhotoContainer>
      <Name variant="textLg">{name}</Name>
      <Role>{role}</Role>
    </TeamMemberRoot>
  );
};

export default TeamMember;
